export type TaxonomyGroup = { category: string; subcategories: string[] };
export const categoryValue = (group: string, subgroup = '') => subgroup ? `${group} · ${subgroup}` : group;
export function taxonomyOptions(groups: TaxonomyGroup[], legacy: string[] = []) {
  const canonical = groups.flatMap(g => g.subcategories.length ? g.subcategories.map(s => categoryValue(g.category, s)) : [g.category]);
  return { groups, legacy: legacy.filter(v => v && !canonical.includes(v)) };
}
export function selectedGroup(value: string, groups: TaxonomyGroup[]) {
  return groups.find(g => value === g.category || g.subcategories.some(s => value === categoryValue(g.category, s)))?.category ?? value;
}
export function validatePDF(file: { name: string; size: number; type: string }): string {
  if (!/\.pdf$/i.test(file.name) || (file.type && file.type !== 'application/pdf')) return 'Choose a PDF file (.pdf).';
  if (!file.size) return 'This file is empty.';
  return file.size > 20 * 1024 * 1024 ? 'PDF exceeds the 20 MiB limit.' : '';
}
export const titleFromFilename = (name: string) => name.replace(/\.pdf$/i, '').replace(/[_-]+/g, ' ').trim().slice(0, 160);
export type UploadEntry = { file: File; title: string; status: 'queued' | 'publishing' | 'published' | 'failed'; error: string };
// Successful entries are never sent again on partial-failure retries.
export async function publishQueue(entries: UploadEntry[], send: (entry: UploadEntry) => Promise<unknown>) {
  for (const entry of entries) {
    if (entry.status === 'published') continue;
    entry.error = validatePDF(entry.file) || (!entry.title.trim() ? 'Enter a document name.' : '');
    if (entry.error) { entry.status = 'failed'; continue; }
    entry.status = 'publishing';
    try { await send(entry); entry.status = 'published'; }
    catch (e) { entry.status = 'failed'; entry.error = e instanceof Error ? e.message : String(e); }
  }
}
